import React from 'react'

export default function TextErrors (props) {
    return <span className="text-left text-danger mx-1"> {props.children}</span>
}